import {
  setNotifyFn
} from "./chunk-7VT7KHV5.mjs";

// src/NotificationProvider.tsx
import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState
} from "react";
import Snackbar from "@mui/material/Snackbar/index.js";
import Alert from "@mui/material/Alert/index.js";
import { jsx, jsxs } from "react/jsx-runtime";
var NotifyContext = createContext(null);
var ERROR_KIND_MESSAGES = {
  network: "We couldn't reach the server. Please check your connection and try again.",
  timeout: "That took too long. Please try again.",
  server: "The server had a problem handling that. Please try again in a moment.",
  client: "That request could not be completed.",
  unknown: "Something went wrong. Please try again."
};
var nextId = 1;
var NotificationProvider = ({ children }) => {
  const [queue, setQueue] = useState([]);
  const [current, setCurrent] = useState(null);
  const [open, setOpen] = useState(false);
  const notify = useCallback(
    (message, severity = "info") => {
      setQueue((prev) => [...prev, { id: nextId++, message, severity }]);
    },
    []
  );
  const notifyError = useCallback(
    (error) => {
      notify(ERROR_KIND_MESSAGES[error.kind], "error");
    },
    [notify]
  );
  useEffect(() => {
    if (!current && queue.length > 0) {
      setCurrent(queue[0]);
      setQueue((prev) => prev.slice(1));
      setOpen(true);
    } else if (current && queue.length > 0 && open) {
      setOpen(false);
    }
  }, [queue, current, open]);
  useEffect(() => {
    setNotifyFn((message) => notify(message, "error"));
    return () => setNotifyFn(null);
  }, [notify]);
  const handleClose = (_event, reason) => {
    if (reason === "clickaway") return;
    setOpen(false);
  };
  const handleExited = () => {
    setCurrent(null);
  };
  return /* @__PURE__ */ jsxs(NotifyContext.Provider, { value: { notify, notifyError }, children: [
    children,
    /* @__PURE__ */ jsx(
      Snackbar,
      {
        open,
        autoHideDuration: 4e3,
        onClose: handleClose,
        TransitionProps: { onExited: handleExited },
        anchorOrigin: { vertical: "bottom", horizontal: "left" },
        children: current ? /* @__PURE__ */ jsx(
          Alert,
          {
            onClose: handleClose,
            severity: current.severity,
            sx: { width: "100%" },
            children: current.message
          }
        ) : void 0
      }
    )
  ] });
};
var useNotify = () => {
  const context = useContext(NotifyContext);
  if (!context) {
    throw new Error("useNotify must be used within a NotificationProvider");
  }
  return context;
};
export {
  NotificationProvider,
  useNotify
};
